import { api } from '@/lib/api';
import type { IApiResponse, IAuditLogPageResponse } from '@skystone/shared';

export const loginActivityApi = {
  getLogins: async (params: { page?: number; pageSize?: number; actorUsername?: string }): Promise<IAuditLogPageResponse> => {
    const searchParams = new URLSearchParams();
    if (params.page) searchParams.set('page', String(params.page));
    if (params.pageSize) searchParams.set('pageSize', String(params.pageSize));
    if (params.actorUsername) searchParams.set('actorUsername', params.actorUsername);
    const query = searchParams.toString();
    const url = query ? `/login-activity?${query}` : '/login-activity';
    const result = await api.get<IApiResponse<IAuditLogPageResponse>>(url);
    return result.data;
  },
};
